export default __webpack_public_path__ + "static/media/bell.0e3a769a.svg";